import { useSelector } from 'react-redux';
import { getRouletteData } from '../ducks';

export const useGetRouletteData = () => {
  const data = useSelector(getRouletteData);
  return data;
};
